// =============================================================================
// RequireAction — route-level entitlement guard.
//
// Renders its children only when the logged-in user's role holds the given
// ActionMaster action (JWT "actions" claim via hasAction); otherwise shows a
// friendly "not entitled" card. Complements the navbar's menu filtering
// (Menu.RequiredActionId) by covering direct-URL navigation. Fallback true =
// sessions from before entitlements shipped keep access until re-login.
// Backend endpoints enforce mutations regardless — this is UX, not security.
// =============================================================================
import React from "react";
import { useNavigate } from "react-router-dom";
import { FaLock } from "react-icons/fa";
import { hasAction } from "../utils/auth";

export default function RequireAction({ action, children }) {
  if (hasAction(action, true)) return children;
  return <NotEntitled />;
}

function NotEntitled() {
  const navigate = useNavigate();
  return (
    <div className="qw-root content-halo content-halo-narrow" style={{
      maxWidth: 520, margin: "120px auto", padding: "36px 32px",
      borderRadius: 16, textAlign: "center",
    }}>
      <FaLock style={{ fontSize: 34, color: "#94A3B8" }} />
      <h4 style={{ marginTop: 14, color: "#0F172A", fontWeight: 700 }}>No access to this page</h4>
      <p style={{ color: "#64748B", fontSize: 14 }}>
        Your role is not entitled to this module. If you believe you should
        have access, ask IT to update your role's permissions — changes
        apply the next time you log in.
      </p>
      <button className="qw-btn qw-btn-primary qw-btn-sm" onClick={() => navigate("/home")}>
        Back to home
      </button>
    </div>
  );
}
